// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1DFCS","header":"MergedInvoice_header__1cOi-"};